
<div>

  <nx-pageTitle-box
    [label]="order?.number"
    [bcRootLvlLabel]="'orderModule.orderViewComponent.orders' | translate"
    [bcRootLvlPath]="'/orders'"
    [icon]="Order.getOrderIcon(order?.type?.toString()) | translate"
    [iconToolTip]="Order.getOrderType(order?.type?.toString()) | translate"
    [menuItems]="pageTitleMenuItems">
    <ng-template nxTemplate="tag">
      <p-tag *ngIf="order?.state" [value]="Order.getOrderState(order?.state + '') | translate" [severity]="order?.getOrderStateSeverity()"></p-tag>
    </ng-template>
  </nx-pageTitle-box>

  <div class="bodyWrapper flex flex-row gap-5">
    <div class="basis-2/3 mt-[10px] widthFixForTable">
      <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">

        <p-tabPanel header="{{'orderModule.orderViewComponent.general' | translate}}">
          <ng-container [ngSwitch]="order?.type">
            <!-- RENTAL -->
            <app-order-rent-line-items
              (refetch)="reload()"
              [lineItems]="order?.lineItems"
              *ngSwitchCase="'RENTAL'">
            </app-order-rent-line-items>

            <!-- OPERATED RENTAL -->
            <app-order-operated-rental-line-items
              (refetch)="reload()"
              [lineItems]="order?.lineItems"
              [orderId]="order?.id"
              *ngSwitchCase="'OPERATED_RENTAL'">
            </app-order-operated-rental-line-items>
            
          </ng-container>
        </p-tabPanel>

        <p-tabPanel header="{{'orderModule.orderViewComponent.tasks' | translate}} ({{tasksCount}})">
          <div class="mt-[1.25rem]">
            <ng-container [ngSwitch]="order?.type">
              <!-- RENTAL -->
              <app-order-task-list-view
                *ngSwitchCase="'RENTAL'"
                [orderId]="this?.id">
              </app-order-task-list-view>

              <!-- OPERATED_RENTAL -->
              <app-order-operated-rental-task-list-view
                *ngSwitchCase="'OPERATED_RENTAL'"
                [orderId]="this?.id">
              </app-order-operated-rental-task-list-view>
            </ng-container>
            
          </div>
        </p-tabPanel>

        <p-tabPanel header="{{'orderModule.orderViewComponent.protocols' | translate}} ({{protocolsCount}})">
          <ng-container [ngSwitch]="order?.type">
             <!-- RENTAL -->
            <app-order-rent-protocols-view
              *ngSwitchCase="'RENTAL'"
              [order]="order">
            </app-order-rent-protocols-view>

            <!-- OPERATED_RENTAL -->
            <app-order-operated-rental-protocols-view
              *ngSwitchCase="'OPERATED_RENTAL'"
              [order]="order">
            </app-order-operated-rental-protocols-view>
          </ng-container>
        </p-tabPanel>

        <p-tabPanel header="{{'orderModule.orderViewComponent.comments' | translate}} ({{order?.noteCount}})">
          <app-activity-stream
            #activityStreamRef
            [title]="'Kommentare'"
            [owner]="order"
            [commentsOnly]="true">
          </app-activity-stream>
        </p-tabPanel> 

        <p-tabPanel header="{{'orderModule.orderViewComponent.files' | translate}} ({{order?.fileCount}})">
          <app-file-list
            [ownerId]="order?.id"
            [ownerType]="'Order'"
            [headline]="'Anhänge'"
            [emptyMessage]="'Dateien hier ablegen oder klicken zum Hochladen (max. 10MB pro Datei)'">
          </app-file-list>
        </p-tabPanel>  

        <p-tabPanel header="Vorgänge ({{issuesCount}})">
          <app-issue-list
            [showTabs]="false"
            [targetEntityType]="'Order'"
            [targetEntityId]="order?.id"
            [showPageTitle]="false"
            *ngIf="order">
          </app-issue-list>
        </p-tabPanel>

        <p-tabPanel header="Zeiterfassung ({{order?.timeEntriesCount}})">
          <app-timeEntry-list
            [ownerId]="order?.id"
            [ownerType]="'Order'"
            [headline]="'Zeiterfassung'"
            [emptyMessage]="'Keine Zeiteinträge vorhanden'">
          </app-timeEntry-list>
        </p-tabPanel>

    </p-tabView>

    </div>
    <div class="basis-1/3 mt-[10px]">
      <div class="flex flex-col">
        <div class="basis-full">
          <ng-container [ngSwitch]="order?.type">

            <!-- RENTAL -->
            <app-order-rent-details
              *ngSwitchCase="'RENTAL'"
              [order]="order">
            </app-order-rent-details>

            <!-- OPERATED RENTAL -->
            <app-order-operated-rental-details
              *ngSwitchCase="'OPERATED_RENTAL'"
              [order]="order">
            </app-order-operated-rental-details>

          </ng-container>
        </div>
      </div>
    </div>
  </div>
